<template>
  <a-button type="primary" v-if="isBtn" @click="setTeamByProjectId()">{{ btnText }}</a-button>
  <a href="javascript:void(0)" v-if="!isBtn && showCount" @click="setTeam()" >{{
    row?.teamsCount
  }}</a>
  <a href="javascript:void(0)" v-if="!isBtn && !showCount" @click="setTeam()" v-perm="'set-team'">{{
    btnText
  }}</a>
  <a-modal
    v-model:visible="visible"
    :centered="true"
    :maskClosable="false"
    width="820px"
    :title="(row?.projectName||projectName) + '团队'"
    @ok="handleOk"
  >
    <table-wrapper
      :row-key="'uuid'"
      :dataSource="dataSource"
      :columns="columns"
      :showCheckbox="false"
      :showTooTip="false"
      :maxHeight="DEFAULTTABLEMAXHEIGHT"
      :row-config="{height: 120}"
    >
      <template #teams="{ record }">
        <user-select
          :validate="'xmfzr' == record.code"
          v-model:value="record.tenantUserIds"
          :disabled="disabled"
          :multiple="true"
          :max-count="['xmfzr', 'tbfzr', 'fafzr', 'xmjl'].includes(record.code) ? 1 : Infinity"
        ></user-select>
      </template>
      <template #roleName="{ record }">
        <span v-if="'xmfzr' == record.code" class="text-red mr5">*</span>{{ record?.roleName }}
      </template>
    </table-wrapper>
    <div style="text-align: right; padding: 5px 0" v-if="row?.projectId">
      <a-button v-perm="'/data-dict/dict/list/project'" @click="openModel" type="link">
        管理项目角色 >
      </a-button>
    </div>
  </a-modal>
  <a-modal
    v-model:visible="visible2"
    :centered="true"
    :maskClosable="false"
    width="420px"
    :title="'管理项目角色'"  
    @ok="handleOk2"
  >
    <table-wrapper
      :row-key="'tenantDictValId'"
      ref="tableRef"
      :dataSource="dataSource2"
      :columns="columns2"
      :showCheckbox="true"
      :showTooTip="false"
       @onSelectionChange="onSelectionChange"
      :maxHeight="DEFAULTTABLEMAXHEIGHT"
      :row-config="{height: 120}"
      :checkbox-config="{checkMethod,checkRowKeys}"
    >
     
    
    </table-wrapper>
    
  </a-modal>
</template>
<script lang="ts" setup>
import { PropType, defineProps, ref, defineEmits, onMounted, nextTick } from "vue";
import { TeamService } from "@/views/project/team/team.service";
import { DEFAULTCOUNTMAX, DEFAULTPRICELENGTH, DEFAULTTABLEMAXHEIGHT } from "@/core/constant";
import { message } from "ant-design-vue";
import { DictValService } from "@/views/data-dict/dict/dict-val.service";
const columns = [
  {
    width: 160,
    key: "roleName",
    title: "项目角色",
    slots: { customRender: "roleName" },
  },
  {
    width: 500,
    key: "teams",
    slots: { customRender: "teams" },
    title: "人员",
  },
];
const columns2 = [
  {
    width: 160,
    key: "roleName",
    title: "项目角色",
  },
  
];
let tableRef=ref();
const props = defineProps({
  row: {
    type: Object as PropType<any>,
    default: () => ({}),
  },
  showCount: {
    type: Boolean,
    default: false,
  },
  btnText: {
    type: String,
    default: "调整团队",
  },
  isBtn: {
    type: Boolean,
    default: false,
  },
  disabled: {
    type: Boolean,
    default: false,
  },
  projectId: {
    type: String,
    default: "",
  },
  projectName: {
    type: String,
    default: "",
  },
  dataRecord: {
    type:  Array as PropType<any>,
    default: () => ([]),
  },
});
const emits = defineEmits(["refresh","addRows"]);
const { data, loading, run, refresh } = TeamService.useTeamUserApi();
const { run: runEdit } = TeamService.useUpdateTeamUserApi();
const { run: runByProjectId } = TeamService.useTeamUserByProjectIdApi();
const { run: runTeamRolesByProjectId } = TeamService.useTeamRolesApi();
const { run: runUpdateTeamRolesByProjectId } = TeamService.useUpdateTeamRolesApi();
const visible = ref(false);
const visible2 = ref(false);
const dataSource = ref([]);
const dataSource2:any = ref([]);
const selectedIds = ref<any>([]);
    const onSelectionChange = (ids: string[]) => {
      selectedIds.value = ids;
      console.log(selectedIds.value);
    };
const setTeam = async () => {
  const res = await run(props.row.id);
  dataSource.value = res?.data.records;
  visible.value = true;
};

const checkMethod=({row})=>{
  return row.roleName!=="项目负责人"
}

const setTeamByProjectId = async () => {
  if(props.dataRecord&&props.dataRecord.length>0){
    dataSource.value = props.dataRecord;
  }else{
    const res = await runByProjectId(props.projectId);
   dataSource.value = res?.data.records;
  }
 
  visible.value = true;
};
const handleOk = async () => {
  let req: any = [];
  let tmp: any = [];
  dataSource.value.map((dd: any) => {
    if ("xmfzr" == dd.code && (!dd.tenantUserIds || dd.tenantUserIds.length == 0)) {
      tmp.push("项目负责人不可为空");
    }
    if (!dd.tenantUserIds) {
      dd.tenantUserIds=[]
      req.push({
        code: dd.code,
        tenantUserId: 0,
      });
    } else if (Array.isArray(dd.tenantUserIds)) {
      if(dd.tenantUserIds.length){
        for (let i = 0; i < dd.tenantUserIds.length; i++) {
        req.push({
          code: dd.code,
          tenantUserId: dd.tenantUserIds[i],
        });
       }
      }else{
        req.push({
          code: dd.code,
          tenantUserId: null,
        });
      }
     
    } else {
      req.push({
        code: dd.code,
        tenantUserId: dd.tenantUserIds,
      });
      dd.tenantUserIds=[dd.tenantUserIds]
    }
  });

  if (tmp.length > 0) {
    message.warning(tmp[0]);
    return;
  }
  if(props.projectId){    
    emits("addRows",dataSource.value);
  }else{
    await runEdit(props.row.id, req);
    emits("refresh");
  }
 
  visible.value = false;
};
const checkRowKeys:any=ref([])
const openModel =async () => {
  visible2.value = true;
  let res=await runTeamRolesByProjectId(props.row.projectId||props.projectId);
  console.log("🚀 ~ openModel ~ res:", res,dataSource2)
  dataSource2.value=res?.data.records||[];

  nextTick(()=>{
    const $table = tableRef.value;
     
    dataSource2.value.forEach((item:any)=>{
    if(item?.selectFlag&&$table){
      selectedIds.value.push(item?.tenantDictValId)
      // checkRowKeys.value.push(item?.tenantDictValId)
      $table.xTable1.setCheckboxRow(item, true);
    }
  })
  })
 
};
const handleOk2 = async () => {
  let params:any=[];
  dataSource2.value.forEach((item:any)=>{

    console.log("🚀 ~ handleOk2 ~ item:", item)

    params.push({
      tenantDictValId:item.tenantDictValId,
      projectId:props.row.projectId||props.projectId,
      selectFlag:Number(selectedIds.value.includes(item.tenantDictValId))
    })  
  })
  await runUpdateTeamRolesByProjectId(props.row.projectId||props.projectId,params);
  const res = await run(props.row.id);
  dataSource.value = res?.data.records;
 
  visible2.value = false;
};
onMounted(async() => {
  // await run2()
})
</script>
<style lang="scss" scoped>
  :deep(.vxe-table--render-default .vxe-header--column.col--ellipsis > .vxe-cell),
:deep(.vxe-table--render-default .vxe-body--column.col--ellipsis > .vxe-cell),
:deep(.vxe-table--render-default .vxe-footer--column.col--ellipsis > .vxe-cell) {
  height: auto !important;
  max-height: 1000px !important;
}
:deep(.vxe-table--render-default .vxe-header--column.col--ellipsis),
:deep(.vxe-table--render-default .vxe-body--column.col--ellipsis),
:deep(.vxe-table--render-default .vxe-footer--column.col--ellipsis),
:deep(.vxe-table--render-default.vxe-editable .vxe-body--column) {
  height: auto !important;
  max-height: 1000px !important;
}
</style>